// Pure helpers for assignment changes — kept free of React so they are unit-testable.

// Compares the chosen lab set against the list's current assignment.
// contract: loan-and-subscription/internalapi/views/user_type/shared/diagnostic/chain/chain_test_list_serializers.py
//   serialize_test_list.assigned_lab_ids + serialize_chain_member_labs (test_source / test_list)
export const computeAssignmentDiff = (labs, list, selected) => {
  const current = new Set(list?.assigned_lab_ids || []);
  const byId = new Map(labs.map((lab) => [lab.id, lab]));
  const added = [...selected].filter((id) => !current.has(id)).map((id) => byId.get(id)).filter(Boolean); // ok: membership diff, not a contract field
  const removed = [...current].filter((id) => !selected.has(id)).map((id) => byId.get(id)).filter(Boolean); // ok: membership diff, not a contract field
  const moved = added.filter((lab) => lab.test_source === "chain" && lab.test_list?.id !== list?.id); // contract: chain_test_list_serializers.py serialize_chain_member_labs test_source
  return { added, removed, moved, changed: added.length + removed.length > 0 };
};

export const selectionFromList = (list) => new Set(list?.assigned_lab_ids || []);
